import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Table,
} from "antd";
import moment from "moment";

import crmApi from "../../../apis/Crm.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";
import CrmDetailComponent from "../salesManage/CrmDetailComponent";

const CrmHistoryCpmponent = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));
  const user = useSelector((state) => state.auth.user);

  const [failStatus, setFailStatus] = useState([]);
  const [dateType, setDateType] = useState("1week");
  const [selectedRowKey, setSelectedRowKey] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [totalCrmHistoryList, setTotalCrmHistoryList] = useState([]);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [modalShow, setModalShow] = useState(false);
  const [selected, setSelected] = useState({});

  const [searchOptions, setSearchOptions] = useState({
    sendStatus: ["total"],
    startDate: moment().subtract(7, "days").startOf("day"),
    endDate: moment().endOf("day"),
    phone: "",
    name: "",
  });
  const [sendList, setSendList] = useState([]);

  const dateTypeItems = [
    { label: "오늘", value: "today" },
    { label: "1주일", value: "1week" },
    { label: "1개월", value: "1month" },
    { label: "3개월", value: "3month" },
    { label: "6개월", value: "6month" },
  ];
  const sendStatusItems = [
    { label: "전체", value: "total" },
    { label: "성공", value: "success" },
    { label: "대기", value: "reservation" },
    { label: "실패", value: "fail" },
  ];

  useEffect(() => {
    readFailStatus();
    getCrmHistoryList("initaial");
  }, []);

  useEffect(() => {
    setSendList(totalCrmHistoryList.slice(offset, offset + pageSize));
  }, [offset, pageSize]);

  useEffect(() => {
    handleChangePagination(currentPageNumber);
  }, [pageSize]);

  const readFailStatus = async () => {
    const res = await crmApi.crmFailList();
    if (res.code === 200) {
      setFailStatus(res.result);
    }
  };

  const getCrmHistoryList = async (
    type = "",
    sendStatus,
    startDate,
    endDate,
  ) => {
    setIsLoading(true);
    try {
      let param;
      if (type === "initial") {
        param = {
          sendStatus: sendStatusItems[0].value,
          startDate: moment()
            .subtract(7, "days")
            .startOf("day")
            .format("YYYYMMDDHHmm"),
          endDate: moment().endOf("day").format("YYYYMMDDHHmm"),
          phone: "",
          name: "",
          userId: user.id === 724 ? 1 : user.id,
        };
      } else if (type === "search") {
        param = {
          sendStatus: searchOptions.sendStatus.join(","),
          startDate: searchOptions.startDate.format("YYYYMMDDHHmm"),
          endDate: searchOptions.endDate.format("YYYYMMDDHHmm"),
          phone: searchOptions.phone,
          name: searchOptions.name,
          userId: user.id === 724 ? 1 : user.id,
        };
      } else if (type === "custom") {
        param = {
          sendStatus: sendStatus,
          startDate: startDate.format("YYYYMMDDHHmm"),
          endDate: endDate.format("YYYYMMDDHHmm"),
          phone: searchOptions.phone,
          name: searchOptions.name,
          userId: user.id === 724 ? 1 : user.id,
        };
      } else {
        param = {
          sendStatus: searchOptions.sendStatus.join(","),
          startDate: searchOptions.startDate.format("YYYYMMDDHHmm"),
          endDate: searchOptions.endDate.format("YYYYMMDDHHmm"),
          phone: searchOptions.phone,
          name: searchOptions.name,
          userId: user.id === 724 ? 1 : user.id,
        };
      }
      const res = await crmApi.searchCrmHistoryList(param);
      if (res.code === 200) {
        if (res.result) {
          setTotalCrmHistoryList(res.result);
        } else {
          setTotalCrmHistoryList([]);
        }
        if (type === "initial" || type === "search") {
          setSendList(res.result.slice(0, 10));
        } else {
          setSendList(res.result.slice(offset, offset + pageSize));
        }
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      // setError(error)
      console.log("getCrmHistoryList read error", error);
    }
  };

  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    setDateType(value);
    switch (value) {
      case "today":
        setSearchOptions({
          ...searchOptions,
          startDate: moment().startOf("day"),
          endDate: moment().endOf("day"),
        });
        break;
      case "1week":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(7, "days").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(7, "days")
              .startOf("day"),
          });
        }
        break;
      case "1month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(1, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "months")
              .startOf("day"),
          });
        }
        break;
      case "3month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(3, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(3, "months")
              .startOf("day"),
          });
        }
        break;
      case "6month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(6, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(6, "months")
              .startOf("day"),
          });
        }
        break;
    }
  };
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onSelect: (record, selected) => {
      let editKeyList = [];
      let editRowList = [];
      if (selected) {
        const filterList = sendList.filter((item) => item.id === record.id);
        const filterKeyList = filterList.map((row) => row.id);
        editRowList = [...selectedRow, ...filterList];
        editKeyList = [...selectedRowKey, ...filterKeyList];
      } else {
        editRowList = selectedRow.filter((item) => item.id !== record.id);
        editKeyList = editRowList.map((row) => row.id);
      }
      setSelectedRowKey(editKeyList);
      setSelectedRow(editRowList);
    },
  };

  const columns = [
    {
      title: "발송타입",
      // width: 100,
      dataIndex: "template_category",
      key: "template_category",
      // fixed: 'left',
      // ellipsis: true,
      // sorter: (a, b) => {}
      render: (value, record) => {
        if (
          record.hasOwnProperty("crmHistoryList") &&
          record.crmHistoryList?.length > 0
        ) {
          let sendType = "기타";
          if (value) {
            if (value.includes("deposit_request")) {
              sendType = `무통장 입금대기 ${value.replace(
                "deposit_request_",
                "",
              )}일차`;
            } else if (value.includes("virtual_account_request")) {
              sendType = `가상계좌 입금대기 ${value.replace(
                "virtual_account_request_",
                "",
              )}일차`;
            } else {
              sendType = record?.template_title;
            }
          }
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <span>
                {record.hasOwnProperty("crmHistoryList") &&
                record.crmHistoryList[0].is_manual
                  ? "직접발송"
                  : "자동발송"}
              </span>
              <span
                className={`gray-font`}
                style={{
                  position: "relative",
                }}
              >
                <div
                  className={`point-div`}
                  style={
                    record.failCnt
                      ? {
                          backgroundColor: "#fe2b4b",
                        }
                      : record.reservationCnt
                      ? {
                          backgroundColor: "#ff8000",
                        }
                      : {
                          backgroundColor: "#7ad629",
                        }
                  }
                />
                {sendType}
              </span>
            </div>
          );
        }
      },
    },
    {
      title: "발송시간",
      // width: 120,
      dataIndex: "created_at",
      key: "created_at",
      // ellipsis: true
      render: (value, record) => {
        if (
          record.hasOwnProperty("crmHistoryList") &&
          record.crmHistoryList?.length > 0
        ) {
          if (record.crmHistoryList[0].crm_send_date) {
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <span>
                  {moment(record.crmHistoryList[0].crm_send_date).format(
                    "YYYY.MM.DD",
                  )}
                </span>
                <span className={`gray-font`}>
                  {moment(record.crmHistoryList[0].crm_send_date).format(
                    "HH:mm:ss",
                  )}
                </span>
              </div>
            );
          } else {
            if (value) {
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <span>{moment(value).format("YYYY.MM.DD")}</span>
                  <span className={`gray-font`}>
                    {moment(value).format("HH:mm:ss")}
                  </span>
                </div>
              );
            }
          }
        } else {
          if (value) {
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <span>{moment(value).format("YYYY.MM.DD")}</span>
                <span className={`gray-font`}>
                  {moment(value).format("HH:mm:ss")}
                </span>
              </div>
            );
          }
        }
      },
    },
    {
      title: "메시지 내용",
      width: 280,
      dataIndex: "message",
      key: "message",
      // ellipsis: true
      render: (_, record) => {
        if (
          record.hasOwnProperty("crmHistoryList") &&
          record.crmHistoryList?.length > 0
        ) {
          return (
            <span className={`ellipse-font`} style={{ textAlign: "left" }}>
              {record.crmHistoryList[0].crm_message}
            </span>
          );
        }
      },
    },
    {
      title: "메시지 유형",
      // width: 120,
      dataIndex: "template_type",
      key: "template_type",
      // ellipsis: true
      render: (value) => {
        if (value === 1) {
          return "카카오 알림톡";
        } else if (value === 3) {
          return "카카오 친구톡";
        } else if (value === 0) {
          return "문자";
        } else {
          return "문자";
        }
      },
    },
    {
      title: "발송건수",
      // width: 120,
      dataIndex: "totalCnt",
      key: "totalCnt",
      // ellipsis: true
    },
    {
      title: "성공",
      // width: 120,
      dataIndex: "successCnt",
      key: "successCnt",
      // ellipsis: true
    },
    {
      title: "실패",
      // width: 120,
      dataIndex: "failCnt",
      key: "failCnt",
      // ellipsis: true
      render: (value) => {
        if (value === 0) {
          return <span>{value}</span>;
        } else {
          return (
            <span
              style={{
                color: "#fe2b4b",
                fontWeight: "bold",
              }}
            >
              {value}
            </span>
          );
        }
      },
    },
    {
      title: "대기",
      // width: 120,
      dataIndex: "reservationCnt",
      key: "reservationCnt",
      // ellipsis: true
      render: (value) => {
        if (value === 0) {
          return <span>{value}</span>;
        } else {
          return (
            <span
              style={{
                color: "#ff8000",
                fontWeight: "bold",
              }}
            >
              {value}
            </span>
          );
        }
      },
    },
    {
      title: "수신자명",
      // width: 120,
      dataIndex: "name",
      key: "name",
      // ellipsis: true
      render: (_, record) => {
        if (
          record.hasOwnProperty("crmHistoryList") &&
          record.crmHistoryList?.length > 0
        ) {
          return record.crmHistoryList[0].target_name;
        }
      },
    },
    {
      title: "수신번호",
      // width: 120,
      dataIndex: "phone",
      key: "phone",
      // ellipsis: true
      render: (_, record) => {
        if (
          record.hasOwnProperty("crmHistoryList") &&
          record.crmHistoryList?.length > 0
        ) {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <span>{record.crmHistoryList[0].target_phone}</span>
              {record.crmHistoryList?.length > 1 && (
                <span className={`gray-font`}>
                  외 {record.crmHistoryList?.length - 1}건
                </span>
              )}
            </div>
          );
        }
      },
    },
    {
      title: "",
      // width: 120,
      dataIndex: "",
      key: "",
      // ellipsis: true
      render: (_, record) => {
        if (record.reservationCnt) {
          return (
            <button
              className="crm-send-btn"
              onClick={(e) => {
                e.stopPropagation();
                handleSendClick(record);
              }}
            >
              발송
            </button>
          );
        }
      },
    },
  ];

  /**
   * 전송 실패 click handler
   */
  const handleFailClick = () => {
    const startDate = moment(
      failStatus[failStatus?.length - 1].updated_at,
    ).startOf("day");
    const endDate = moment(failStatus[0].updated_at).endOf("day");
    setDateType("");
    setSearchOptions({
      ...searchOptions,
      sendStatus: ["fail"],
      startDate: startDate,
      endDate: endDate,
    });
    getCrmHistoryList("custom", "fail", startDate, endDate);
  };

  /**
   * 전송 상태 click handler
   */
  const handleSearchOptionChange = (e) => {
    const { value, checked } = e.target;
    let currSendStatus = searchOptions.sendStatus;
    if (value === "total") {
      if (checked) {
        currSendStatus = [value];
      }
    } else {
      if (checked) {
        currSendStatus.push(value);
        if (currSendStatus.includes("total")) {
          currSendStatus = currSendStatus.filter((item) => item !== "total");
        }
      } else {
        currSendStatus = currSendStatus.filter((item) => item !== value);
        if (currSendStatus?.length === 0) {
          currSendStatus = ["total"];
        }
      }
    }
    setSearchOptions({
      ...searchOptions,
      sendStatus: currSendStatus,
    });
  };

  /**
   * 검색
   */
  const handleSearch = () => {
    setOffset(0);
    setPageSize(10);
    setCurrentPageNumber(1);
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert("조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.");
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          "조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.",
        );
      } else {
        getCrmHistoryList("search");
      }
    }
  };

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      sendStatus: ["total"],
      name: "",
      phone: "",
      startDate: moment().subtract(7, "days").startOf("day"),
      endDate: moment().endOf("day"),
    });
    setDateType(dateTypeItems[1].value);
    setOffset(0);
    setPageSize(10);
    setCurrentPageNumber(1);
    setSelectedRowKey([]);
    setSelectedRow([]);
    getCrmHistoryList("initial");
  };

  /**
   * 예약건 발송처리 click handler (2023.03.20) - ksb
   */
  const handleSendClick = async (record) => {
    const filteredList = record.crmHistoryList.filter(
      (crmHistory) => crmHistory.crm_is_send === 3,
    );
    if (
      window.confirm(
        `${filteredList[0].target_name}님${
          filteredList?.length > 1
            ? ` 외 ${filteredList?.length - 1}건을`
            : "에게"
        } CRM을 전송하시겠습니까?\n"확인"을 누를시, 최대 5분 이내에 자동으로 전송됩니다.`,
      )
    ) {
      setIsLoading(true);
      try {
        const param = {
          crmIdList: filteredList.map((crmHistory) => crmHistory.id),
          userId: user.id,
        };
        const res = await crmApi.changeCRMListToWait(param);
        if (res.code === 200) {
          alert(
            `총 ${res.result}건 발송 예약 처리되었습니다.\n5분 이후에 확인해주세요!`,
          );
          handleInitialBtnClick();
        } else {
          throw res.msg;
        }
        setIsLoading(false);
      } catch (e) {
        setIsLoading(false);
        alert(e);
      }
    }
  };

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const currOffset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(currOffset);
  };

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
    setOffset((current - 1) * pageSize);
  };

  return (
    <>
      <ContentHeaderComponent title="CRM 내역" />
      <div className="product-register-wrap">
        <Row className="product-search-product-status-wrap">
          {/*취소요청*/}
          <Col md={5}>
            <Row className="product-status-box-wrap">
              <img
                className="product-status-icon"
                src={`/assets/images/salesManage/send-fail.png`}
                alt={`전송실패`}
              />
              <div className="product-status-text">
                <div>전송실패</div>
                <div onClick={handleFailClick} style={{ cursor: "pointer" }}>
                  <span
                    className="product-status-num"
                    style={{
                      color: "#fe2b4b",
                    }}
                  >
                    {failStatus?.length}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>
          </Col>
        </Row>
        {/*CRM 내역 검색*/}
        <div className="product-search-box-wrap">
          <Form.Item
            className="center-label"
            label="전송상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            {sendStatusItems.map((item, idx) => (
              <Checkbox
                key={`send_status_${idx}`}
                name="sendStatus"
                value={item.value}
                onChange={handleSearchOptionChange}
                checked={searchOptions.sendStatus.includes(item.value)}
              >
                {item.label}
              </Checkbox>
            ))}
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row
              align={"middle"}
              style={{ marginTop: 10, rowGap: "1rem", gap: 5 }}
            >
              <span
                className={`another-gray-font`}
                style={{ marginRight: "1rem" }}
              >
                전송일
              </span>
              <Radio.Group
                className={`options-list`}
                options={dateTypeItems}
                onChange={handleDateTypeChange}
                value={dateType}
                optionType="button"
              />
              <Row align={"middle"} style={{ rowGap: "1rem", gap: "1rem" }}>
                <DatePicker
                  className="order-search-date-wrap"
                  format="YYYY/MM/DD"
                  allowClear={false}
                  value={searchOptions.startDate}
                  onChange={(value) => {
                    setDateType("");
                    setSearchOptions({ ...searchOptions, startDate: value });
                  }}
                />
                ~
                <DatePicker
                  className="order-search-date-wrap"
                  format="YYYY/MM/DD"
                  allowClear={false}
                  value={searchOptions.endDate}
                  onChange={(value) => {
                    setDateType("");
                    setSearchOptions({ ...searchOptions, endDate: value });
                  }}
                />
              </Row>
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="상세검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align={"middle"} style={{ rowGap: "1rem", gap: "1rem" }}>
              <div className={`input-div`}>
                <span className={`another-gray-font`}>수신번호</span>
                <Input
                  name="phone"
                  value={searchOptions.phone}
                  onChange={(e) => {
                    setSearchOptions({
                      ...searchOptions,
                      phone: e.target.value,
                    });
                  }}
                  placeholder={`수신번호`}
                  onPressEnter={handleSearch}
                />
              </div>
              <div className={`input-div`}>
                <span className={`another-gray-font`}>수신자명</span>
                <Input
                  name="name"
                  value={searchOptions.name}
                  onChange={(e) => {
                    setSearchOptions({
                      ...searchOptions,
                      name: e.target.value,
                    });
                  }}
                  placeholder={`수신자명`}
                  onPressEnter={handleSearch}
                />
              </div>
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Row className="inquiry-search-button-wrap" justify="center">
            <Button
              className="inquiry-search-button search"
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className="inquiry-search-button initial"
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <div>
            <span className="product-register-box-title">
              전송 목록 (총{" "}
              <span
                className="product-register-box-subtitle"
                style={{ marginLeft: 0 }}
              >
                {totalCrmHistoryList?.length}
              </span>
              개)
            </span>
            {/*<span className="product-list-subtitle">orderPair[orderType]}</span>*/}
          </div>
          {/*<Button className="order-excel-download-btn" icon={<img style={{height: 14.2, width: 14.5, marginRight: 5}} src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/microsoftexcel.png`} />} onClick={handleExcelDownloadClick}>엑셀다운</Button>*/}
        </Row>
        <div
          className="product-register-border-box"
          wrap={false}
          style={{ padding: "20px 25px 40px", height: "fit-content" }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={sendList}
            loading={isLoading}
            tableLayout={"auto"}
            bordered
            size="middle"
            rowKey="id"
            className={"table-class"}
            rowClassName="coupon-table-row"
            // scroll={{x: 'calc(700px + 50%)'}}
            scroll={{ x: "max-content" }}
            // onChange={handleTableChange}
            pagination={false}
            onRow={(record, rowIndex) => {
              return {
                onClick: (event) => {
                  setSelected(record);
                  setModalShow(true);
                },
              };
            }}
          />

          <div style={{ textAlign: "right" }}>
            <Pagination
              showSizeChanger
              pageSize={pageSize}
              onShowSizeChange={pageSizeChange}
              total={totalCrmHistoryList?.length}
              onChange={handleChangePagination}
              style={{ marginTop: 20 }}
              current={currentPageNumber}
            />
          </div>
        </div>
      </div>
      {modalShow && (
        <Modal
          title="전송 상세보기"
          wrapClassName="order-detail-modal-wrap"
          visible={modalShow}
          centered={true}
          onCancel={() => {
            setModalShow(!modalShow);
            setSelected({});
          }}
          footer={null}
          width="70%"
        >
          <CrmDetailComponent
            crm={selected}
            handleModalCancel={() => {
              setModalShow(!modalShow);
              setSelected({});
            }}
            getCrmHistoryList={getCrmHistoryList}
          />
        </Modal>
      )}
    </>
  );
};

export default CrmHistoryCpmponent;
